import { Controller } from "@hotwired/stimulus"
import { Dropzone } from "dropzone"

// Контроллер для поддержки drag-and-drop загрузки файлов через Dropzone
export default class extends Controller {
  static targets = ["input", "fileName", "placeholder"]

  connect() {
    // Настраиваем Dropzone на контейнере (this.element)
    this.dropzone = new Dropzone(this.element, {
      url: "/", // Мы не будем использовать встроенную отправку Dropzone
      autoProcessQueue: false, // Отключаем авто-загрузку
      maxFiles: 1,
      clickable: true,
      previewsContainer: false, // Мы будем сами выводить имя файла
      accept: (file, done) => {
        done()
      }
    })

    // По событию выбора/броска файла
    this.dropzone.on("addedfile", (file) => {
      this.updateUI(file)
      this.syncWithHiddenInput(file)
    })

    // Обработка удаления файла из Dropzone (если потребуется)
    this.dropzone.on("removedfile", () => {
      this.resetUI()
    })
  }

  disconnect() {
    if (this.dropzone) {
      this.dropzone.destroy()
    }
  }

  // Обновляем интерфейс при выборе файла
  updateUI(file) {
    if (this.hasFileNameTarget) {
      this.fileNameTarget.textContent = `Выбран файл: ${file.name}`
      this.fileNameTarget.classList.remove("hidden")
    }
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("hidden")
    }
  }

  // Сброс интерфейса
  resetUI() {
    if (this.hasFileNameTarget) {
      this.fileNameTarget.textContent = ""
      this.fileNameTarget.classList.add("hidden")
    }
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.remove("hidden")
    }
  }

  // Синхронизируем Dropzone файл со скрытым инпутом формы для обычной оправки через submit
  syncWithHiddenInput(file) {
    if (this.hasInputTarget) {
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      this.inputTarget.files = dataTransfer.files
    }
  }

  // Если пользователь выбрал файл через стандартный диалог (клик на Label -> Hidden Input)
  // Мы также должны это учесть, хотя Dropzone перехватывает клики поclickable: true
  handleInputChange(event) {
    const file = event.target.files[0]
    if (file) {
      this.updateUI(file)
    }
  }
}
